import { render, staticRenderFns } from "./bjlist.vue?vue&type=template&id=674b5c12&"
import script from "./bjlist.vue?vue&type=script&lang=js&"
export * from "./bjlist.vue?vue&type=script&lang=js&"
import style0 from "./bjlist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports